var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
// -----------------------------------------------------------------------------
// Helper: ensure that Scenario.nodes is ALWAYS returned as an array.
// On the backend this field is stored as TEXT, so depending on the CRUD method
// we can receive either an already-parsed array or a raw JSON string.  To avoid
// scattering defensive checks across the codebase we normalise the payload here.
// -----------------------------------------------------------------------------
const normalizeScenario = (sc) => {
    const normalizeNodes = (nodes) => {
        if (!nodes)
            return [];
        if (Array.isArray(nodes))
            return nodes;
        if (typeof nodes === 'string') {
            try {
                return JSON.parse(nodes);
            }
            catch (_a) {
                return [];
            }
        }
        return [];
    };
    return Object.assign(Object.assign({}, sc), { nodes: normalizeNodes(sc.nodes) });
};
/**
 * Get all scenarios for a level
 */
export const getLevelScenarios = (levelId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const scenarios = yield client.get(`/levels/${levelId}/scenarios`);
        return scenarios.map(normalizeScenario);
    }
    catch (error) {
        console.error('Error fetching level scenarios:', error);
        return [];
    }
});
/**
 * Get scenario by ID
 */
export const getScenarioById = (levelId, scenarioId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const scenario = yield client.get(`/levels/${levelId}/scenarios/${scenarioId}`);
        return normalizeScenario(scenario);
    }
    catch (error) {
        console.error(`Error fetching scenario ${scenarioId}:`, error);
        return null;
    }
});
/**
 * Create a new scenario
 */
export const createScenario = (levelId, scenario) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const created = yield client.post(`/levels/${levelId}/scenarios`, scenario);
        return normalizeScenario(created);
    }
    catch (error) {
        console.error('Error creating scenario:', error);
        throw error;
    }
});
/**
 * Update existing scenario
 */
export const updateScenario = (levelId, scenarioId, scenario) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const updated = yield client.put(`/levels/${levelId}/scenarios/${scenarioId}`, scenario);
        return normalizeScenario(updated);
    }
    catch (error) {
        console.error(`Error updating scenario ${scenarioId}:`, error);
        throw error;
    }
});
/**
 * Delete scenario
 */
export const deleteScenario = (levelId, scenarioId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield client.delete(`/levels/${levelId}/scenarios/${scenarioId}`);
    }
    catch (error) {
        console.error(`Error deleting scenario ${scenarioId}:`, error);
        throw error;
    }
});
